import { create } from 'zustand';
import { PixTransactionResponse, TransactionStatus } from '../../services/gateway.service';

type State = {
    isVisible: boolean;
    isPending: boolean,
    status: TransactionStatus | null;
    response: PixTransactionResponse | null;
    saleId: null | number;
    method: PaymentMethod | null;
    card: PaymentCard | null;
    installments: number | null;
    isntallmentsVisibility: boolean;
    purchaseTotal: number | null;
};

type Action = {
    close: () => void;
    update: (data: Partial<State>) => void;
};


export type PaymentMethod = 'card' | 'pix' | 'finished' | null;
export type PaymentCard = {
    subMethod: 'DEBIT' | 'CREDIT' | null;
    brand: string;
    cvv: string;
    name: string;
    number: string;
    expiration: string;
};

export const usePaymentModalStore = create<State & Action>(set => ({
    isVisible: false,
    isPending: false,
    saleId: null,
    method: null,
    installments: null,
    isntallmentsVisibility: false,
    status: null,
    response: null,
    card: null,
    purchaseTotal: null,
    close: () => {
        set(() => ({
            isVisible: false,
            saleId: null,
            method: null,
            card: null,
            installments: null,
            status: null,
            response: null,
            isPending: false,
            isntallmentsVisibility: false,
            purchaseTotal: null
        }));
    },
    update: (data: Partial<State>) => {
        set(state => ({
            ...state,
            ...data,
        }));
    },
}));
